import React from 'react';

import classes from './index.module.scss';

const SearchAndFilter = ({
  searchRef,
  searchHandler,
  searchText,
  dateRef,
  filterByDateHandler
}) => {
  return (
    <div>
      <div className="row mb-5">
        <div className="col-sm-6 col-lg-8 mb-2 mb-sm-0">
          <div className={classes.searchFilter_table_search}>
            <input
              type="text"
              className={`form-control ${classes.searchFilter_table_search_input}`}
              placeholder={`Search by ${searchText}`}
              aria-label="search"
              aria-describedby="button-addon2"
              ref={searchRef}
              onKeyDown={searchHandler}
            />
          </div>
        </div>
        <div className="col-sm-6 col-lg-4">
          <div className={`row gx-2 ${classes.searchFilter_filter}`}>
            <div className="col-7">
              <input
                type="date"
                name="filter_date"
                ref={dateRef}
                placeholder="Choose Filter Date"
                className={`form-control ${classes.searchFilter_filter_input}`}
              />
            </div>
            <div className="col-5">
              <button onClick={filterByDateHandler} className="btn" type="button">
                Apply Filter
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchAndFilter;
